import { storageItems } from '@va/standalone/shared/constants';
import { getTypo3LocaleQueryParamValue, toQueryString } from '@va/util/helpers';
import Config from 'Config';

export type AnnouncementBannerContent = {
  id: string;
  matches: string;
  text_html: string;
  text_plain: string;
  icon: string;
  bg_color: string;
  text_color: string;
  href_match: string;
  internalAppUrl: string;
};

type AnnouncementBannerResponse = {
  payload: {
    info: {
      datetime: string;
    };
  } & Record<string, AnnouncementBannerContent[]>;
  meta: {
    page: number;
    pageSize: number | null;
    pageTotal: number | null;
    total: number | null;
  };
};

export const getAnnouncementBanner: (websiteId: string, locale: string) => Promise<AnnouncementBannerResponse> = async (
  websiteId,
  locale,
) => {
  const queryData = {
    locale: getTypo3LocaleQueryParamValue(locale),
    websiteId: websiteId,
  };

  const overrideData = localStorage.getItem(storageItems.inappBannersOverride);

  if (overrideData) {
    try {
      const parsed = JSON.parse(overrideData);
      return Promise.resolve(parsed);
    } catch (e) {
      console.error('Invalid announcement banners JSON', e);
    }
  }

  const url = `${Config.announcementBannerApiUrl}?${toQueryString(queryData)}`;
  const options = url.includes('dev')
    ? {
        headers: {
          Authorization: `Basic ${btoa(`visa:8vY$B7@xE*oD#B`)}`,
        },
      }
    : {};

  const response = await fetch(url, options);

  return response.json();
};
